module.exports = __webpack_public_path__ + "static/logo-imc-trading-298defd6552bf6fc8aeb0be7484afd56.svg";